export const LOADING_COMPETENCIES_TOTAL = "LOADING_COMPETENCIES_TOTAL";
export const SAVE_LOADING_COMPETENCIES_TOTAL = "SAVE_LOADING_COMPETENCIES_TOTAL";
export const GET_COMPETENCIES_TOTAL = "GET_COMPETENCIES_TOTAL";
export const FORM_FAIL = "FORM_FAIL";
export const COMPETENCIES_TOTAL_FAIL = "COMPETENCIES_TOTAL_FAIL";
export const LOADING_COMPETENCIES_TOTAL_BY_ID = "LOADING_COMPETENCIES_TOTAL_BY_ID";
export const GET_COMPETENCIES_TOTAL_BY_ID = "GET_COMPETENCIES_TOTAL_BY_ID";

